import React from 'react';
import type { MenuLanguage } from '../main-menu/types.js';

export function TutorialOfferDialog({ language, onTutorial, onSkip }: {
  language: MenuLanguage;
  onTutorial: () => void;
  onSkip: () => void;
}) {
  const tr = (es: string, en: string, fr: string) =>
    language === 'es' ? es : language === 'fr' ? fr : en;
  return <div className="tutorial-offer-backdrop">
    <section className="tutorial-offer" role="dialog" aria-modal="true"
      aria-labelledby="tutorial-offer-title" data-game-input="ignore">
      <span className="tutorial-offer-mark" aria-hidden="true">✦</span>
      <h2 id="tutorial-offer-title">{tr('¿Es tu primera partida?', 'Is this your first match?', 'Est-ce votre première partie ?')}</h2>
      <p>{tr('Aprende lo básico en menos de un minuto.', 'Learn the basics in under a minute.', 'Apprenez les bases en moins d’une minute.')}</p>
      <button className="tutorial-offer-primary" onClick={onTutorial}>
        ▶ {tr('Jugar tutorial', 'Play tutorial', 'Jouer au tutoriel')}
      </button>
      <button className="tutorial-offer-skip" onClick={onSkip}>
        {tr('Saltar', 'Skip', 'Passer')}
      </button>
    </section>
  </div>;
}

